import jsCookie from 'js-cookie';
import { PAGE_VIEW_COOKIE_NAME } from '../config/cookieNames';

const trackPageViews = () => {
    const count = jsCookie.get(PAGE_VIEW_COOKIE_NAME);
    const newCount = typeof count === 'undefined' ? 1 : parseInt(count, 10) + 1;
    jsCookie.set(PAGE_VIEW_COOKIE_NAME, newCount);
};

export default trackPageViews;
